import { render, staticRenderFns } from "./CourseMenu.vue?vue&type=template&id=39ec13f6&scoped=true&"
import script from "./CourseMenu.vue?vue&type=script&lang=js&"
export * from "./CourseMenu.vue?vue&type=script&lang=js&"
import style0 from "./CourseMenu.vue?vue&type=style&index=0&id=39ec13f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ec13f6",
  null
  
)

export default component.exports